import {ISpecificSafezoneObject} from "./safezone-object-factory.service.interface";
import {
  CHANNEL,
  CLOSE_SAFEZONE_SOURCE,
  CLOSE_SAFEZONE_SOURCE_VALUES, ISafezoneHandler,
  OPEN_SAFEZONE_SOURCE,
  OPEN_SAFEZONE_SOURCE_VALUES,
  SAFEZONE_CONTAINERS_ID
} from "./safezone.service.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {ISafezoneEventParams, SESSION_STATUS} from "../analytics/analytics-data-layer.service.interface";


export default abstract class SafezoneHandlerBase implements ISafezoneHandler {
  protected _safezoneObject: ISpecificSafezoneObject = null;
  protected _services: IServiceFactoryExtended;
  protected _renderErrorInterval: number | undefined;
  protected _ready: boolean = false;
  protected _correlationId: string;

  protected abstract _category: string;
  protected abstract _openEventName: string;
  protected abstract _readyEventName: string;
  protected abstract _closeEventName: string;
  protected abstract _containerId: SAFEZONE_CONTAINERS_ID;
  protected abstract _channel: CHANNEL;
  closedFromSafezone:boolean = false;

  constructor(services: IServiceFactoryExtended){
    this._services = services;
  }

  public init(safezoneObj: ISpecificSafezoneObject): void {
    this._safezoneObject = safezoneObj;
  }

  public onReady(): void {
    this._ready = true;
    this._clearRenderErrorInterval();
  }

  protected _closeSafezone(source: CLOSE_SAFEZONE_SOURCE_VALUES): void {
    this._sendCloseEvent();
    this._ready = false;
    this._clearRenderErrorInterval();
    try {
      this._safezoneObject.close(this._services.window.getGlobalProperty(CLOSE_SAFEZONE_SOURCE)[source], this._containerId);
    } catch (err) {
      this._services.logger.error("Safezone Full close error", err);
    }
  }

  protected _renderSafezone(source: OPEN_SAFEZONE_SOURCE_VALUES, correlationId?:string): void {
    // correlation id is sent only in case the full opens from mini, correlation is must be the same in this case
    if (correlationId){
      this._correlationId = correlationId;
    } else {
      this._correlationId = this._services.tools.getGuid();
    }

    this._services.analyticsDataLayer.pushSafezoneEvent(this._getEventParams(this._openEventName));
    this._ready = false;
    this.closedFromSafezone = false;
    this._clearRenderErrorInterval();
    this._renderErrorInterval = setInterval(() => {
      this._sendRenderErrorEvent();
    }, 7000);
    try {
      this._safezoneObject.render(this._containerId, this._services.window.getGlobalProperty(OPEN_SAFEZONE_SOURCE)[source], this._correlationId);
    } catch (err) {
      this._services.logger.error(this._category +" safezone render error", err);
    }
  }

  private _sendRenderErrorEvent(): void {
    this._services.analyticsDataLayer.pushSafezoneEvent({
      ...this._getEventParams(this._readyEventName),
      session_status: SESSION_STATUS.Failure
    });
  }

  protected _sendCloseEvent():void {
    const status = this._ready ? SESSION_STATUS.Success : SESSION_STATUS.Partial;
    this._services.analyticsDataLayer.pushSafezoneEvent({
      ...this._getEventParams(this._closeEventName),
      session_status: status
    });
  }

  protected _getEventParams(name: string): ISafezoneEventParams {
    return {
      action: name,
      category: this._category,
      event: name,
      correlation_id: this._correlationId,
      channel: this._channel,
      label: undefined,
      local_time: (new Date()).toString()
    }
  }

  protected _clearRenderErrorInterval() {
    if (this._renderErrorInterval) {
      clearInterval(this._renderErrorInterval);
      this._renderErrorInterval = undefined;
    }
  }

  public resetOnLogout(): void {
    this.closedFromSafezone = false;
    this._clearRenderErrorInterval();
  }
}